import { SegmentTabs } from '@/components/ui/page-toolbar'
import { CloserToolbarSelect } from '@/components/CloserLeads/CloserToolbarSelect'
import { GestorTabFiltersBar } from '@/components/Gestores/GestorTabFiltersBar'
import { FINANCE_QUEUE_LIFECYCLE_TABS } from '@/components/Financeiro/financeQueueLifecycle'
import { FINANCE_AREA_META, type FinanceAreaKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'
import type { FinanceQueueLifecycle } from '@/components/Financeiro/financeQueueLifecycle'

const AREA_OPTIONS = Object.entries(FINANCE_AREA_META).map(([key, meta]) => ({
  value: key as FinanceAreaKey,
  label: meta.label,
}))

type Props = {
  queueLifecycle: FinanceQueueLifecycle
  setQueueLifecycle: (v: FinanceQueueLifecycle) => void
  queueSearch: string
  setQueueSearch: (v: string) => void
  queueArea: string
  setQueueArea: (v: string) => void
}

export function GestorChamadosFilters({
  queueLifecycle,
  setQueueLifecycle,
  queueSearch,
  setQueueSearch,
  queueArea,
  setQueueArea,
}: Props) {
  const areaOptions = [{ value: '', label: 'Todas as áreas' }, ...AREA_OPTIONS]
  const hasActiveFilter = queueSearch.trim().length > 0 || Boolean(queueArea) || queueLifecycle !== 'ativos'

  const clearAllFilters = () => {
    setQueueSearch('')
    setQueueArea('')
    setQueueLifecycle('ativos')
  }

  return (
    <div className='space-y-3'>
      <SegmentTabs
        value={queueLifecycle}
        onChange={(value) => setQueueLifecycle(value as FinanceQueueLifecycle)}
        tabs={[...FINANCE_QUEUE_LIFECYCLE_TABS]}
        ariaLabel='Situação dos chamados'
        className='w-full overflow-x-auto'
      />

      <GestorTabFiltersBar
        search={queueSearch}
        onSearchChange={setQueueSearch}
        searchPlaceholder='Buscar protocolo ou tipo…'
        searchAriaLabel='Buscar chamados'
        showClear={hasActiveFilter}
        onClearAll={clearAllFilters}
      >
        <CloserToolbarSelect
          value={queueArea}
          onChange={setQueueArea}
          options={areaOptions}
          aria-label='Filtrar por área'
        />
      </GestorTabFiltersBar>
    </div>
  )
}
